export const environment = {
  production: false,
  apiUrl: "https://apitest.clearline.me",
  selfServicePortalUrl: ""
};
